import { createLocators } from '@u1/locators';
import React from 'react';

const fallbackLocators = createLocators({
  name: 'Avatar',
  componentLocators: ['fallback'],
});
const { locators } = fallbackLocators();

export const Fallback: React.FC<{ className: string; size: number }> = ({
  className,
  size,
}) => (
  <svg
    viewBox="0 0 340 340"
    className={className}
    style={{ width: size, height: size }}
    {...locators.fallback()}
  >
    <path
      fill="currentColor"
      d="m169,.5a169,169 0 1,0 2,0zm0,86a76,76 0 1
1-2,0zM57,287q27-35 67-35h92q40,0 67,35a164,164 0 0,1-226,0"
    />
  </svg>
);
